// extracted by mini-css-extract-plugin
export default {"surveySection":"surveySection-epbZOP"};